import { render, staticRenderFns } from "./PopupFormItem.vue?vue&type=template&id=c0691be0&scoped=true&"
import script from "./PopupFormItem.vue?vue&type=script&lang=js&"
export * from "./PopupFormItem.vue?vue&type=script&lang=js&"
import style0 from "./PopupFormItem.vue?vue&type=style&index=0&id=c0691be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0691be0",
  null
  
)

export default component.exports